import { CompanyAPI } from '@api';

const updateBus = (form) => CompanyAPI.updateBus(form)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { updateBus };
